import { useEffect } from 'react';

type TFormFields = {
  amount?: string | number | null;
  period?: string | null;
  purpose?: string | null;
};

/** Синхронизирует значения полей анкеты с query параметрами */
export const useSyncFormFieldsToQueryParams = (params: TFormFields, enabled = true) => {
  const { amount, period, purpose } = params;

  useEffect(() => {
    if (!enabled || !window) return;

    const { pathname, search } = window.location;
    const searchParams = new URLSearchParams(search);

    Object.entries({ amount, period, purpose }).forEach(([key, value]) => {
      if (!value) {
        searchParams.delete(key);
      } else {
        searchParams.set(key, value.toString());
      }
    });

    const newSearch = searchParams.toString();

    window.history.replaceState(null, document.title, [pathname, newSearch].filter(Boolean).join('?'));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, amount, period, purpose]);
};
